import BatchOptimizationService from '@/application/services/BatchOptimization'
import Util from  '@/application/libs/util'
import eventModule from  '@/application/libs/eventModule'
import moment from 'moment';
import { t } from 'i18next'

const waitForGridBuildTimeout = 50;
let CDPICTPROD = null;
let infoBatch = {};
const emptyChar = String.fromCharCode(0x00A0);
const fetchBatchData = function(batchScenarioPanel){
    return BatchOptimizationService.fetchBatchData().then(res => {
        batchScenarioPanel.validityOptions = res;
        return res;
    });
};

const _focusGridCell = (grid, fieldName, rowIndex = 0) => {
    grid.gridControl.clearFocusedCell(); // clear current focused cells
    grid.gridControl.ensureColumnVisible(fieldName);
    grid.gridControl.startEditingCell({ rowIndex, colKey: fieldName});
};

const _addEmptyOption = function(promiseRequest, emptyOption){
    return promiseRequest.then( dataSet => [emptyOption].concat(dataSet));
};

const isSearchButton = ( el ) => {
    let name = el && typeof el.getAttribute == 'function' 
        ? (el.getAttribute('name') || '') 
        : '';
    let parentName = el && el.parentElement && typeof el.parentElement.getAttribute == 'function'
        ? el.parentElement.getAttribute('name') || ''
        : '';
    return name.toLowerCase().includes('searchbutton') 
           || parentName.toLowerCase().includes('searchbutton');
};

const batchScenarioGrid = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('unit') } , field: "NMFILIAL", editable: false, pinned: 'left',
          checkboxSelection: true, 
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
            onCellDoubleClicked: () => _focusGridCell(batchScenarioGrid, "NMFILIAL"),
        },
        { headerValueGetter: ()=> {return t('service') } , field: "NMSERVICO",editable: false, pinned: 'left',
            onCellDoubleClicked: () => _focusGridCell(batchScenarioGrid, "NMSERVICO"),
        },
        { headerValueGetter: ()=> {return t('dt_reference') } , field: "DTREFERENCIA",  
            editable: true, cellEditor: "dateCellEditor", minWidth: 150,
            cellEditorParams: {updateKey: "UPDATEDTREFERENCIA"}
        },
        { headerValueGetter: ()=> {return t('cost_type') } , field: "NMTIPOCUSTO", 
            editable: true,
            cellEditor: "vSelectCellEditor",
            sortable: true, 
            filter: "agTextColumnFilter",
            cellEditorParams: {
                optionsSearchFunction: () => BatchOptimizationService.getTypeCost(),
                valueColumn: "CDTIPOCUSTO",
                labelColumn: "NMTIPOCUSTO",
                remoteFilter: false,
                searchableColumns: ["NMTIPOCUSTO"],
                outDataColumns: ["CDTIPOCUSTO", "NMTIPOCUSTO"],
                updateKey: "UPDATETYPECOST",
            },
            
        },
        { headerValueGetter: ()=> {return t('standard_cost') } , field: "VRCUSTOPADRAO", editable: true,
            cellEditorParams: {updateKey: "UPDATECUSTO"},
        },
        { headerValueGetter: ()=> {return t('vr_minimum') } , field: "VRCUSTOMIN", editable: true,
            cellEditorParams: {updateKey: "UPDATECUSTO"}
        },
        { headerValueGetter: ()=> {return t('vr_maximum') } , field: "VRCUSTOMAX", editable: true,
            cellEditorParams: {updateKey: "UPDATECUSTO"}
        },
        { headerValueGetter: ()=> {return t('group_products_cong_card') } , field: "NMGRUPPROD",
            editable: true,
            cellEditor: "vSelectCellEditor",
            sortable: true, 
            filter: "agTextColumnFilter",
            cellEditorParams: {
                optionsSearchFunction: () => _addEmptyOption(BatchOptimizationService.getGrupProd(), {CDGRUPPROD: null, NMGRUPPROD: emptyChar}),
                valueColumn: "CDGRUPPROD",
                labelColumn: "NMGRUPPROD",
                remoteFilter: false,
                searchableColumns: ["NMGRUPPROD"],
                outDataColumns: ["CDGRUPPROD", "NMGRUPPROD"],
                updateKey: "UPDATEGRUPPROD"
            },
        },
        {
            headerValueGetter: ()=> {return t('allows_to_freeze') } , field: "IDPERMITECONGELAR",
            cellRenderer: ( param ) => {
                const { IDPERMITECONGELAR } = param.data;
                const decode = {
                    'S': 'Sim',
                    'N': 'Não'
                };
                return decode[IDPERMITECONGELAR];
            }
        },
        { headerValueGetter: ()=> {return t('frozen_days') } , field: "QTDIASCONG",
            cellEditorParams: {
                updateKey: 'UPDATEDIASCONG'
            }, 
            editable: (param) => param.data.IDPERMITECONGELAR === 'S',
        },
        { headerValueGetter: ()=> {return t('link_scenario') } , field: "NRCENARIOVINCULO",
            editable: true,
            cellEditor: "vSelectCellEditor",
            sortable: true, 
            filter: "agTextColumnFilter",
            cellEditorParams: {
                optionsSearchFunction: async function(params){
                    let panel = document.querySelector('#panel-container').firstElementChild.__vue__.panel;
                    let selectedBatch = panel.selectedBatch;
                    const { CDFILIAL, CDSERVFILI } = this.editingRow;
                    const { TPCONTRATO: IDTIPORESTRICAO, DTMESCARD: DTMESGERACAOCARD } = Util.getFilterInSession();
                    return _addEmptyOption(BatchOptimizationService.getLinkedScenario({DTMESGERACAOCARD, IDTIPORESTRICAO, CDFILIAL, CDSERVFILI}), {NRCENARIOVINCULO: emptyChar});
                },
                valueColumn: "NRCENARIOVINCULO",
                labelColumn: "NRCENARIOVINCULO",
                remoteFilter: false,
                searchableColumns: ["NRCENARIOVINCULO"],
                outDataColumns: ["NRCENARIOVINCULO"],
                updateKey: "UPDATELINKEDSCENARIO",
            },
        },
        { headerValueGetter: ()=> {return t('alerts') } , field: "IDSTATUSALERTA", editable: false, 
            minWidth: 200,
            onCellClicked: function( cell ) {
                
                const isEnabled = ( el ) => {
                    let disabled = el && typeof el.getAttribute == 'function' ? el.getAttribute('disabled') : null;
                    disabled = disabled === null ? false : disabled;
                    return !disabled;
                };
                if(cell && cell.event && isSearchButton(cell.event.target) && isEnabled(cell.event.target)){
                    BatchOptimizationService.getGenerationAlert(cell.data.NRITGERACAOCARD).then( data => {
                        showAlertGridModal(data, cell.data);
                    });
                }
            },
            cellRenderer: (param) => {
                const { IDSTATUSALERTA, DTALERTA } = param.data;
                const icons = {
                    NAO_INICIADO: { nameClass: "fas fa-minus", style: `color: grey;` },
                    ANDAMENTO   : { nameClass: "fa-1x fas fa-spinner fa-pulse", style: `color: grey;`},
                    ERRO: { 
                        nameClass: "fas fa-exclamation",
                        style: `color: red;`
                    },
                    OK: {
                        nameClass: "fas fa-check",
                        style: `color: green;`
                    },
                    default: {
                        nameClass: `fas fa-minus`,
                        style: `color: grey;`
                    }
                };
                const WITHOUT_ALERT = ['OK', null].includes(IDSTATUSALERTA);
                const currentIcon = icons[IDSTATUSALERTA] || icons.default;
                const { nameClass, style } = currentIcon;
                let disabled = WITHOUT_ALERT ? `disabled=true` : "";
                return `<div class="alert-cell">
                            <div>
                                <i style="${style}" class="${nameClass}"></i>
                            </div>
                            <span>${DTALERTA || ''}</span>
                            <div title="Visualizar Alertas" name="searchButtonDiv" 
                                class="search-button ${WITHOUT_ALERT ? "alert-disabled" : "alert-enabled"}" ${disabled}>
                                <i name="searchButtonIcon" ${disabled} class="fas fa-magnifying-glass"></i>
                            </div>
                        </div>`;
            }
        },
        { headerValueGetter: ()=> {return t('status') } , field: "IDSTATUSGERACAO", editable: false, 
            onCellDoubleClicked: () => _focusGridCell(batchScenarioGrid, "IDSTATUSGERACAO"),
            maxWidth: 100,
            cellRenderer: (param) => {
                const { IDSTATUSGERACAO } = param.data;
                const icons = {
                    NAO_INICIADO: { nameClass: "fas fa-minus", style: `color: grey;` },
                    ANDAMENTO   : { nameClass: "fa-1x fas fa-spinner fa-pulse", style: `color: grey;`},
                    FINALIZADO_COM_ERRO: { 
                        nameClass: "fas fa-exclamation",
                        style: `color: red;`
                    },
                    FINALIZADO_SEM_ERRO: {
                        nameClass: "fas fa-check",
                        style: `color: green;`
                    },
                    ERRO: {
                        nameClass: "fas fa-times",
                        style: `color: red;`
                    },
                    PUBLICADO_SEM_ERRO   : {
                        nameClass: "fas fa-calendar-check",
                        style: `color: #37943a;`
                    },
                    PUBLICADO_COM_ERRO   : {
                        nameClass: "fas fa-calendar-times",
                        style: `color: red;`
                    },
                    default: {
                        nameClass: `fas fa-minus`,
                        style: `color: grey;`
                    }
                };
                const currentIcon = icons[IDSTATUSGERACAO] || icons.default;
                const { nameClass, style } = currentIcon;
                return `<div style="text-align: center">
                            <i style="${style}" class="${nameClass}"></i>
                        </div>`;
            }
        },
        { headerValueGetter: ()=> {return t('scenario_no') } , field: "NRCENARIOCARD", editable: false,
            onCellDoubleClicked: () => _focusGridCell(batchScenarioGrid, "NRCENARIOCARD"),
        },
        { headerValueGetter: ()=> {return t('scenario_nr_to_be_published') } , field: "NRCENARIOPUBLICAR", editable: true,
            cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: function( ){
                    return _addEmptyOption(BatchOptimizationService.getSceneryPublish(this.editingRow), {NRCENARIOPUBLICAR: emptyChar});
                },
                valueColumn: "NRCENARIOPUBLICAR",
                labelColumn: "NRCENARIOPUBLICAR",
                remoteFilter: false,
                searchableColumns: ["NRCENARIOPUBLICAR"],
                outDataColumns: ["NRCENARIOPUBLICAR"],
                updateKey: "UPDATECENARIOPUBLICAR"
            }
        }
        
    ],
    defaultColDef: {
        onCellValueChanged: function(propColumn){
            return saveBatchScenarioGrid(propColumn);
        }, 
        resizable: true, lockVisible: true, editable: true, sortable: true, filter: "agTextColumnFilter"
    },
    lazyLoad: true,
    dataSource: BatchOptimizationService.getBatchScenario,
    dataSourceFilter: {},
    onRowClicked: ( event ) => {
        if(!isSearchButton(event.event.target)){
            refreshGenerationSummary(event.data);
            refreshPublicSummary(event.data);
        }
    },
};

const generationSummaryGrid = {
    decode: {
        BURACO          : 'hole',
        CUSTO_FORA_META : 'cost_off_target',
        INCIDENCIA      : 'out_of_incidence',
        UNEXPECTED_ERROR: 'error_in_generation',
        FLEXIBLE_RULE   : 'flexible_rule'
    },
    columnDefs: [
        { headerValueGetter: ()=> {return t('type') } , field: "IDTIPOLOG", checkboxSelection: false, editable: false,
            minWidth: 150,
            onCellDoubleClicked: () => _focusGridCell(batchScenarioGrid, "IDTIPOLOG"),
            cellRenderer: ( param ) => {
                const { IDTIPOLOG } = param.data;
                return t(generationSummaryGrid.decode[IDTIPOLOG]);
            }
        },
        { headerValueGetter: ()=> {return t('description') } , field: "DSLOGGERACAOCARD", editable: false,
            onCellDoubleClicked: () => _focusGridCell(batchScenarioGrid, "DSLOGGERACAOCARD"),
            cellRenderer: ( param ) => {
                const { DSLOGGERACAOCARD, IDTIPOLOG } = param.data;
                switch (IDTIPOLOG) {
                    case 'CUSTO_FORA_META':
                        const parametrosMSG_cost = DSLOGGERACAOCARD.split('$');
                        return t('msg_cost_outside_target_batch_summary',
                                {COST:parametrosMSG_cost[0], 
                                PU_GENERATED:parametrosMSG_cost[1],
                                DIFFERENCE:parametrosMSG_cost[2]});
                        break;
                    case 'INCIDENCIA':
                        const parametrosMSG_incidence = DSLOGGERACAOCARD.split('$');
                        if(parametrosMSG_incidence[0] == 'freqError'){
                            return t('msg_incidence_batch_summary_freqError',
                                    {PLATE_GROUP:parametrosMSG_incidence[1], 
                                    MIN_MONTH:parametrosMSG_incidence[2],
                                    MAX_MONTH:parametrosMSG_incidence[3],
                                    TOTAL:parametrosMSG_incidence[4]});

                        } else if(parametrosMSG_incidence[0] == 'freqErrorWeek'){
                            return t('msg_incidence_batch_summary_freqErrorWeek',
                                    {PLATE_GROUP:parametrosMSG_incidence[1], 
                                    MAX_WEEK:parametrosMSG_incidence[2],
                                    TOTAL:parametrosMSG_incidence[3],
                                    START:parametrosMSG_incidence[4],
                                    END:parametrosMSG_incidence[5]});
                        }
                        break;
                    case 'BURACO':
                        const parametrosMSG_hole = DSLOGGERACAOCARD.split('$');
                        return t('msg_hole_batch_summary',
                                {DATA:parametrosMSG_hole[0], 
                                TYPE_DISH:parametrosMSG_hole[1]});
                        break;
                    case 'FLEXIBLE_RULE':
                        const parametrosMSG_rule = DSLOGGERACAOCARD.split('$');
                        return t('msg_flexible_rule_batch_summary',
                        {DATA:parametrosMSG_rule[0], 
                        TYPE_DISH:parametrosMSG_rule[1],
                        FLEXIBLE_RULE:t(parametrosMSG_rule[2])});
                        break;
                }
            }
        }
        
    ],
    formatValuesExport: function(grid, data){
        let copyData = Object.assign({}, data);
        const typeLog = grid.decode;
        copyData.IDTIPOLOG = typeLog[data.IDTIPOLOG];
        return copyData;
    },
    defaultColDef: {resizable: true, lockVisible: true, editable: false, sortable: true, filter: "agTextColumnFilter"},
    lazyLoad: true,
    dataSource: BatchOptimizationService.getGenerationSummary,
    dataSourceFilter: {},
};

const publicationSummaryGrid = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('item') } , field: "DSITEM", checkboxSelection: false, editable: false,
            minWidth: 150,
            onCellDoubleClicked: () => _focusGridCell(batchScenarioGrid, "DSITEM"),
        },
        { headerValueGetter: ()=> {return t('description') } , field: "DSERRO", editable: false,
            onCellDoubleClicked: () => _focusGridCell(batchScenarioGrid, "DSERRO"),
        }
        
    ],
    defaultColDef: {resizable: true, lockVisible: true, editable: false, sortable: true, filter: "agTextColumnFilter"},
    lazyLoad: true,
    dataSource: BatchOptimizationService.getPublicationSummary,
    dataSourceFilter: {},
};

const refreshBatchOptimizationOptionsData = async (selectedBatch) => {
    infoBatch.selectedBatch = selectedBatch;
    batchScenarioGrid.dataSourceFilter.NRGERACAOCARD = (selectedBatch && selectedBatch.NRGERACAOCARD) || null;
    let promise = new Promise(function(resolve) {
        setTimeout(async () => {
            let response = await batchScenarioGrid.reloadData();
            resolve(response);
        }, waitForGridBuildTimeout);
    });
    return promise;
};

const refreshGenerationSummary = (selectedBatch, simpleReload = false) => {
    let resolvePromise;
    let promise = new Promise(res=>resolvePromise = res);
    if(!simpleReload){
        generationSummaryGrid.dataSourceFilter.NRITGERACAOCARD = (selectedBatch && selectedBatch.NRITGERACAOCARD) || null;
    }
    setTimeout(()=>{
        generationSummaryGrid.reloadData().then( data => {
            resolvePromise(data);
        });
    }, waitForGridBuildTimeout);
    return promise;
};

const refreshPublicSummary = (selectedBatch, simpleReload = false) => {
    let resolvePromise;
    let promise = new Promise(res=>resolvePromise = res);
    if(!simpleReload){
        publicationSummaryGrid.dataSourceFilter.NRLOGINTCARDAMES = (selectedBatch && selectedBatch.NRLOGINTCARDAMES) || null;
    }
    setTimeout(()=>{
        publicationSummaryGrid.reloadData().then( data => {
            resolvePromise(data);
        });
    }, waitForGridBuildTimeout);
    return promise;
};

const socketRefreshGenerationSummary = (NRITGERACAOCARD, isSelected, numberRowsSelected) => {
    let reloadGrid = isSelected && numberRowsSelected === 1;
    if(reloadGrid) {
        refreshGenerationSummary({NRITGERACAOCARD});
    }
};

const socketRefreshPublicationSummary = (NRLOGINTCARDAMES , isSelected, numberRowsSelected) => {
    let reloadGrid = isSelected && numberRowsSelected === 1;
    if(reloadGrid) {
        refreshPublicSummary({NRLOGINTCARDAMES});
    }
};

const organizeObjectNewBatch = function(batchData) {
    let objectBatch = {};
    let services = batchData.checkedService ? batchData.services : batchData.selectedService;
    objectBatch.MONTH = moment(batchData.selectedMonth, 'YYYY-MM').format('DD/MM/YYYY');
    objectBatch.SERVICES = services.map( service => service.CDFILIAL + service.CDSERVFILI );
    objectBatch.DTREFERENCIA = batchData.selectedDateRef ? moment(batchData.selectedDateRef, 'YYYY-MM-DD').format('DD/MM/YYYY') : null;
    objectBatch.CDTIPOCUSTO = batchData.selectedTypeCost && batchData.selectedTypeCost.CDTIPOCUSTO && batchData.selectedTypeCost.CDTIPOCUSTO != '' ? batchData.selectedTypeCost.CDTIPOCUSTO : null;
    objectBatch.CDAGRUPPROD =  batchData.selectedAgrupProd && batchData.selectedAgrupProd.CDGRUPPROD &&  batchData.selectedAgrupProd.CDGRUPPROD != '' ?  batchData.selectedAgrupProd.CDGRUPPROD : null;
    return objectBatch;
};

const updateStatusItGeracaoCard = function( NRITGERACAOCARD, IDSTATUSGERACAO, NRCENARIOPUBLICAR, NRLOGINTCARDAMES){
    return BatchOptimizationService.updateStatusItGeracaoCard(NRITGERACAOCARD, IDSTATUSGERACAO, NRCENARIOPUBLICAR, NRLOGINTCARDAMES);
};

const updateStatusItems = function( ALL_NRITGERACAOCARD, IDSTATUSGERACAO ) {
    return BatchOptimizationService.updateStatusItems({ALL_NRITGERACAOCARD, IDSTATUSGERACAO});
};

const generateScenery = function( scenery ){
    return BatchOptimizationService.generateScenery(scenery);
};

const calculateAlert = function ( params ) {
    return BatchOptimizationService.calculateAlert( params );
};

const getCabecalhoExportLog = function( NRITGERACAOCARD ){
    return BatchOptimizationService.getCabecalhoExportLog( NRITGERACAOCARD );
};

const publishScenery = function( scenery ){
    const { NRCENARIOCARD, NRCENARIOPUBLICAR } = scenery;
    scenery.NRCENARIOCARD = NRCENARIOPUBLICAR && NRCENARIOPUBLICAR !== emptyChar ? NRCENARIOPUBLICAR : NRCENARIOCARD;
    BatchOptimizationService.publishScenery(scenery);
};

const valueToFloat = function(value){
    if(typeof value !== 'string') return value;
    let not_digits = value.match(/[^\d]+/gi);
    if(!not_digits) return parseFloat(value);
    if(not_digits.length > 2) return `INVALID_NUMBER`;
    let [thousand, decimal = thousand] = not_digits;
    if(thousand == decimal) thousand = ' ';
    return parseFloat(value.split(thousand).join('').split(decimal).join('.'));
}

const compare = function(v1,v2, operator){
    if((v1 || v1 === 0) && (v2 || v2 === 0)){
        switch(operator){
            case '>': return v1 > v2;
            case '<': return v1 < v2;
            case '<=': return v1 <= v2;
            case '>=': return v1 >= v2;
            default: return 'INVALID_OPERATOR';
        }
    }
    return null;
};

const setParameters = function(data, field, params, values) {
    const {oldValue, newValue} = values;
    let COST_FIELDS = ['VRCUSTOPADRAO', 'VRCUSTOMIN', 'VRCUSTOMAX'];
    params.NRITGERACAOCARD = data.NRITGERACAOCARD;
    const INVALID_NUMBER_MSG = {
        isValid: false,
        title: t('invalid_number'),
        message: t('number_entered_is_invalid')
    };
    if(field === 'NMTIPOCUSTO') {
        params.CDTIPOCUSTO = data.CDTIPOCUSTO;
    } else if(field == 'NMGRUPPROD'){
        params.CDGRUPPROD = data.CDGRUPPROD;
        params.DTMESCARD = infoBatch.selectedBatch.DTMESGERACAOCARD;
        params.CDFILIAL = data.CDFILIAL;
        params.IDPERMITECONGELAR = data.IDPERMITECONGELAR;
    } else if(field == 'NRCENARIOVINCULO'){
        params.NRCENARIOVINCULO = data.NRCENARIOVINCULO == emptyChar ? null : data.NRCENARIOVINCULO;
    } else if(field == 'DTREFERENCIA'){
        params.DTREFERENCIA = data.DTREFERENCIA;
    } else if(field == 'QTDIASCONG'){
        params.QTDIASCONG = data.QTDIASCONG;
    } else if(COST_FIELDS.includes(field)){
        if(oldValue && !newValue && newValue !== 0) {// remove values in grid;
            params[field] = null;
            COST_FIELDS.forEach( fieldName => {
                if(fieldName !== field){
                    params[fieldName] = data[fieldName];
                }
            });
        } else { // update values in grid
            const isEmpty = value => !value;
            let floatValueEdited = valueToFloat(data[field]);
            if(floatValueEdited === 'INVALID_NUMBER') {
                data[field] = oldValue;
                return INVALID_NUMBER_MSG;
            }
            params.VRCUSTOPADRAO = !isEmpty(data.VRCUSTOPADRAO) ? valueToFloat(data.VRCUSTOPADRAO) : null;
            params.VRCUSTOMIN    = !isEmpty(data.VRCUSTOMIN)    ? valueToFloat(data.VRCUSTOMIN)    : null;
            params.VRCUSTOMAX    = !isEmpty(data.VRCUSTOMAX)    ? valueToFloat(data.VRCUSTOMAX)    : null;
            
            let {VRCUSTOPADRAO, VRCUSTOMIN, VRCUSTOMAX} = params;
            const validations = {isValid: true};
            if(field === 'VRCUSTOPADRAO' && !isEmpty(VRCUSTOPADRAO) && isEmpty(VRCUSTOMIN) && isEmpty(VRCUSTOMAX)){
                params.VRCUSTOMIN = VRCUSTOPADRAO;
                params.VRCUSTOMAX = VRCUSTOPADRAO;
                VRCUSTOMIN = VRCUSTOPADRAO;
                VRCUSTOMAX = VRCUSTOPADRAO;
            }
            const custo = {
                custoMinPadrao: compare(VRCUSTOMIN, VRCUSTOPADRAO, '<=') ,
                custoMinMax: compare(VRCUSTOMIN, VRCUSTOMAX, '<='),
                custoMaxMin: compare(VRCUSTOMAX, VRCUSTOMIN, '>=') ,
                custoMaxPadrao: compare(VRCUSTOMAX, VRCUSTOPADRAO, '>=')
            };
            if(custo.custoMinPadrao === false || custo.custoMinMax == false){
                validations.isValid = false;
                validations.title = t('invalid_value');
                validations.message = t('minimum_cost_must_be_greater_than_or_equal_to_standard_cost_and_maximum_cost');
            } else if(custo.custoMaxMin === false || custo.custoMaxPadrao == false){
                validations.isValid = false;
                validations.title = t('invalid_value');
                validations.message = t('maximum_cost_must_be_greater_than_or_equal_to_standard_cost_and_minimum_cost');
            }
            if(validations.isValid){
                data.VRCUSTOMIN = params.VRCUSTOMIN;
                data.VRCUSTOMAX = params.VRCUSTOMAX;
                data[field] = params[field];
            } else {
                data[field] = oldValue;
            }
            return validations;
        }
    } else if(field == 'NRCENARIOPUBLICAR'){
        params.NRITGERACAOCARD = data.NRITGERACAOCARD;
        params.NRCENARIOPUBLICAR = data.NRCENARIOPUBLICAR == emptyChar ? null : data.NRCENARIOPUBLICAR;
    }
};

const newBatchProcedureCaller = function(batchData, modal, data, verifyAlert, verifyCost) {
    let objectNewBatch = organizeObjectNewBatch(batchData);
    objectNewBatch.VERIFY_ALERT = verifyAlert ? 'S' : 'N';
    objectNewBatch.VERIFY_COST  = verifyCost ? 'S' : 'N';
    return BatchOptimizationService.newBatchProcedureCaller(objectNewBatch).then( response => {
        data._showLoad = true;
        Util.showSuccessNotification({ title: t('saved_successfully')});
        modal.hide('new-batch-modal');
        if(response && response.status && response.status.NRGERACAOCARD){
            return response.status.NRGERACAOCARD;
        }
        return null;
    }).catch((error) => {
        data._showLoad = true;
        data._messageError.title = t('error_new_batch');
        data._messageError.message = error;
        modal.show("messageError");
    });
};

const showModal = function(title, message){
    eventModule.$emit('showMessageModal', {title, message});
};

const showAlertGridModal = function( dataSet, otherInfo ){
    eventModule.$emit('showAlertGridModal', {dataSet, otherInfo});
};
const saveCost = function(params, updateKey = 'UPDATECUSTO'){
    return BatchOptimizationService.saveBatchScenarioGrid(params, updateKey);
};

const saveBatchScenarioGrid = function(propColumn){
    let col = propColumn.colDef;
    let data = propColumn.data;
    let field = col.field;
    let params = {};
    const {oldValue, newValue} = propColumn;
    // if(propColumn.newValue == propColumn.oldValue) return;
    let validations = setParameters(data, field, params, {oldValue, newValue});
    
    if(validations && !validations.isValid){
        propColumn.api.redrawRows({rowNodes: [propColumn.node]});
        let {title, message} = validations;
        showModal(title, message);
        return;
    }
    BatchOptimizationService.saveBatchScenarioGrid(params, col.cellEditorParams.updateKey)
        .then((result) => {
            if (result && result.error) {
                throw result;
            } else if(result){
                batchScenarioGrid.enableSelection();
                let data = result && result.dataset && (typeof result.dataset.data == 'object') ? result.dataset.data : {};
                let redrawRow = data.CUSTO || data.hasOwnProperty('QTDIASCONG');
                
                if( data.QTDIASCONG ){
                    propColumn.data.QTDIASCONG = result.dataset.data.QTDIASCONG;
                } else if( data.CUSTO ){
                    const { VRCUSTOPADRAO, VRCUSTOMIN, VRCUSTOMAX } = data.CUSTO;
                    propColumn.data.VRCUSTOPADRAO = VRCUSTOPADRAO;
                    propColumn.data.VRCUSTOMIN = VRCUSTOMIN;
                    propColumn.data.VRCUSTOMAX = VRCUSTOMAX;
                }
                if( redrawRow ) {
                    propColumn.api.redrawRows({rowNodes: [propColumn.node]});
                }
                
                Util.showSuccessNotification({ title: t('saved_successfully')});
            }
        })
        .catch((e = {}) => {
            Util.showErrorNotification({ title: t('unable_to_save_changes'), text: e.error });
        });
};

const getLinkedService = async function( NRGERACAOCARD ){
    const linkedService = await BatchOptimizationService.getLinkedService( NRGERACAOCARD );
    const parentsUnitServ = new Map();
    let mapped = linkedService.reduce((mapItems, item) => {
        mapItems[item.NRITGERACAOCARD] = item;
        let parentFiliServKey = `FILISERV_${item.CDFILIALORIG}${item.CDSERVORIG}`;
        if(parentsUnitServ.has(parentFiliServKey)){
            parentsUnitServ.get(parentFiliServKey).children.push(item.NRITGERACAOCARD);
        } else {
            parentsUnitServ.set(parentFiliServKey, {children: [item.NRITGERACAOCARD]});
        }
        return mapItems;
    }, {});
    return {
        CHILDREN: mapped,
        PARENT: parentsUnitServ
    };
};

export default {
    registerContext:function(){},
    
    batchScenarioGrid,
    generationSummaryGrid,
    publicationSummaryGrid,
  
    
    fetchBatchData,
    refreshBatchOptimizationOptionsData,
    refreshGenerationSummary,
    refreshPublicSummary,
    organizeObjectNewBatch,
    saveBatchScenarioGrid,
    generateScenery,
    publishScenery,
    calculateAlert,
    newBatchProcedureCaller,
    updateStatusItGeracaoCard,
    updateStatusItems,
    socketRefreshGenerationSummary,
    socketRefreshPublicationSummary,
    getCabecalhoExportLog,
    valueToFloat,
    saveCost,
    getLinkedService
}